import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import i18n from './i18n'; // initialize i18next before the app renders
import App from './App';

// Suppress browser extension errors in development
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', function(e) {
    if (e.message && e.message.includes('Extension context invalidated')) {
      e.preventDefault();
      console.warn('Browser extension error suppressed:', e.message);
      return false;
    }
  });
  
  // Also suppress unhandled promise rejections from extensions
  window.addEventListener('unhandledrejection', function(e) {
    if (e.reason && e.reason.message && e.reason.message.includes('Extension context invalidated')) {
      e.preventDefault();
      console.warn('Browser extension promise rejection suppressed:', e.reason.message);
      return false;
    }
  });
}

// Set document title from centralized strings
if (typeof document !== 'undefined' && i18n.t('common.appTitle')) {
  document.title = i18n.t('common.appTitle');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
